import { render, staticRenderFns } from "./ExcTabsButtons.vue?vue&type=template&id=33bf40f2&"
import script from "./ExcTabsButtons.vue?vue&type=script&lang=js&"
export * from "./ExcTabsButtons.vue?vue&type=script&lang=js&"
import style0 from "./ExcTabsButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports